module.exports = __webpack_public_path__ + "dbe50ec47820327bb322d02c34a0c4ad.work1.svg";


//////////////////
// WEBPACK FOOTER
// ./containers/workWithUsPage/assets/work1.svg
// module id = DzBa
// module chunks = 0